import {
  getBreadcrumbsObject,
  LegacyBreadcrumbType,
} from "#routers/breadcrumbsHelper";
import { useSearchParams } from "#routers/hooks";
import { FORM_SUBMISSION_LIST_BREADCRUMB } from "#src/Routers/breadcrumbs";
import { DraftFormSubmissionsList } from "#src/batteries-included-components/Layouts/Form/Submission/List/DraftFormSubmissionsList";
import { NonDraftFormSubmissionsList } from "#src/batteries-included-components/Layouts/Form/Submission/List/NonDraftFormSubmissionsList";
import {
  generateDocumentTitle,
  Page,
  Tab,
} from "@validereinc/common-components";
import { ResourceDefinitions } from "@validereinc/domain";
import * as PropTypes from "prop-types";
import React from "react";
import { Titled } from "react-titled";

// TODO: refactor this and the shared component under components/Common/Forms/FormTable into one component
const FormSubmissionList = ({
  breadcrumbs,
}: {
  breadcrumbs: LegacyBreadcrumbType[];
}) => {
  const [searchParams, setSearchParams] = useSearchParams<{ tab: string }>();

  return (
    <Titled
      title={generateDocumentTitle(
        breadcrumbs.at(-1)?.title ?? FORM_SUBMISSION_LIST_BREADCRUMB.title,
        breadcrumbs.at(-2)?.title
      )}
    >
      <Page
        title="Form Submissions"
        onActiveTabKeyChange={(newKey: string) =>
          setSearchParams({ tab: newKey })
        }
        activeTabKey={searchParams?.tab ?? "submissions"}
        breadcrumbs={getBreadcrumbsObject(breadcrumbs)}
      >
        <Tab
          tabKey="submissions"
          title="Submissions"
        >
          <NonDraftFormSubmissionsList />
        </Tab>

        <Tab
          tabKey="drafts"
          title="Drafts"
        >
          <Titled
            title={(pt) =>
              `Draft ${ResourceDefinitions.form_submission.label.plural} | ${pt}`
            }
          />
          <DraftFormSubmissionsList />
        </Tab>
      </Page>
    </Titled>
  );
};

FormSubmissionList.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
};

export default FormSubmissionList;
